import { createContext as P, useContext as x, useMemo as w, useReducer as he, useRef as H, useEffect as fe, useCallback as C, useState as pe } from "react";
import { jsx as v, jsxs as Se } from "react/jsx-runtime";
import { QueryClient as ge, QueryClientProvider as me, useQueryClient as G, useQuery as ye, useInfiniteQuery as we } from "@tanstack/react-query";
import { useRequester as ve } from "@made-people/react-use-requester";
import { useInjectStructuredDataProducts as xe } from "@made-people/grease-structured-data";
const b = P(
  void 0
), W = P(void 0);
function Pe() {
  const e = x(W);
  if (e === void 0)
    throw new Error(
      "useFacetSorting must be used within a SearchResultProvider"
    );
  return e;
}
const Z = P([]), Re = () => {
  const e = x(Z);
  if (e === void 0)
    throw new Error("useExcludedFacets must be used within a SearchProvider");
  return e;
}, z = new ge({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1e3,
      // 5 minutes
      gcTime: 30 * 60 * 1e3,
      // 30 minutes
      retry: 2,
      retryDelay: (e) => Math.min(1e3 * 2 ** e, 3e4)
    },
    mutations: {
      retry: 1
    }
  }
}), et = () => {
  z.clear();
}, B = ({
  children: e,
  queryClient: t = z
}) => /* @__PURE__ */ v(me, { client: t, children: e });
B.displayName = "SearchResultReactQueryProvider";
const J = P(
  null
), Ce = () => x(J), be = (e) => {
  var s, o;
  const t = {
    globalSearchSettings: e.globalSearchSettings,
    searchData: e.searchData,
    structuredDataMapper: e.structuredDataMapper
  }, r = {
    facets: ((s = e.facetSorting) == null ? void 0 : s.facets) ?? "auto",
    values: ((o = e.facetSorting) == null ? void 0 : o.values) ?? "auto"
  }, n = e.excludedFacets ?? [];
  return /* @__PURE__ */ v(b.Provider, { value: t, children: /* @__PURE__ */ v(Z.Provider, { value: n, children: /* @__PURE__ */ v(J.Provider, { value: e.facetGrouping ?? null, children: /* @__PURE__ */ v(W.Provider, { value: r, children: /* @__PURE__ */ v(B, { children: e.children }) }) }) }) });
};
be.displayName = "SearchProvider";
const tt = {
  search: "search"
}, Y = P(void 0), rt = (e) => {
  const t = {
    autoCompleteClient: e.autoCompleteClient
  };
  return /* @__PURE__ */ v(Y.Provider, { value: t, children: e.children });
}, Ee = () => {
  const e = x(Y);
  if (!e)
    throw new Error(
      "useAutoCompleteClient must be used within a AutoCompleteProvider"
    );
  return e.autoCompleteClient;
}, nt = () => {
  const e = Ee();
  return ve(async (r) => {
    try {
      return await e.search(r);
    } catch (n) {
      throw n;
    }
  });
};
function Fe(e, t) {
  switch (t.type) {
    case "SET_RESULT":
      return {
        ...e,
        result: t.payload
      };
    case "LOAD_PAGE":
      return e.result ? {
        ...e,
        result: {
          ...e.result,
          items: [...e.result.items, ...t.payload.items],
          meta: {
            ...e.result.meta,
            currentPage: t.payload.page
          }
        }
      } : e;
    default:
      return e;
  }
}
const q = P(void 0), ee = P(void 0);
function E() {
  const e = x(q);
  if (e === void 0)
    throw new Error(
      "useSearchResultState must be used within a SearchResultProvider"
    );
  return e;
}
function ke() {
  var t;
  return (t = E().result) == null ? void 0 : t.items;
}
const te = () => {
  const e = x(b);
  if (!e)
    throw new Error(
      "useStructuredDataProductsMapper must be used within a SearchProvider"
    );
  return e.structuredDataMapper;
}, Ie = (e) => {
  const t = ke(), r = te(), n = w(() => {
    if (!r)
      return;
    const s = [];
    return t == null || t.forEach((o) => {
      o.type === "product" && s.push(r(o.product));
    }), s;
  }, [t]);
  return xe(n), null;
}, re = P(void 0), ne = (e) => {
  const [t, r] = he(Fe, {
    result: e.result
  }), n = H(!0), s = te();
  return fe(() => {
    n.current ? n.current = !1 : r({ type: "SET_RESULT", payload: e.result });
  }, [e.result]), /* @__PURE__ */ v(q.Provider, { value: t, children: /* @__PURE__ */ Se(ee.Provider, { value: r, children: [
    s && /* @__PURE__ */ v(Ie, {}),
    e.children
  ] }) });
};
ne.displayName = "SearchResultProvider";
const Qe = (e, t, r) => {
  const n = t && Object.keys(t).length > 0, s = r && r.length > 0;
  return n && s ? ["search", e, "facets", t, "sort", r] : n ? ["search", e, "facets", t] : s ? ["search", e, "sort", r] : ["search", e];
}, F = (e, t, r) => Qe(
  e,
  Object.keys(t).length > 0 ? t : void 0,
  r.length > 0 ? r : void 0
), k = (e, t) => {
  const r = e.values.map((s) => s.id === t ? {
    ...s,
    selected: !s.selected
  } : s), n = r.filter((s) => s.selected).length;
  return {
    ...e,
    values: r,
    selectedCount: n
  };
}, se = (e, t) => e.map((r) => {
  if (r.id === t) {
    const n = !r.selected;
    if (r.children && r.children.length > 0) {
      const s = (o) => o.map((a) => ({
        ...a,
        selected: n,
        children: a.children ? s(a.children) : a.children
      }));
      return {
        ...r,
        selected: n,
        children: s(r.children)
      };
    } else
      return {
        ...r,
        selected: n
      };
  }
  return r.children ? {
    ...r,
    children: se(r.children, t)
  } : r;
}), ce = (e) => e.map((t) => {
  if (t.children && t.children.length > 0) {
    const r = ce(t.children), n = r.every(
      (s) => s.selected
    );
    return {
      ...t,
      selected: n,
      children: r
    };
  }
  return t;
}), I = (e, t) => {
  const r = se(e.values, t), n = ce(r), s = (a) => a.reduce((u, c) => {
    let d = c.selected ? 1 : 0;
    return c.children && (d += s(c.children)), u + d;
  }, 0), o = s(n);
  return {
    ...e,
    values: n,
    selectedCount: o
  };
}, Q = (e) => {
  const t = [];
  for (const r of e)
    r.selected && t.push(r), r.children && t.push(
      ...Q(r.children)
    );
  return t;
}, Le = (e) => {
  const t = [], r = (n) => {
    for (const s of n) {
      if (s.selected) {
        t.push(s);
        continue;
      }
      s.children && s.children.length > 0 && r(s.children);
    }
  };
  return r(e), t;
}, De = async (e, t, r, n) => {
  let s = e;
  for (const [o, a] of Object.entries(t)) {
    const u = s.facets.find((d) => d.id === o);
    if (!u)
      continue;
    let c = [...s.facets];
    for (const d of a)
      u.type === "checkbox" ? c = c.map((l) => l.id === o && l.type === "checkbox" ? k(l, d) : l) : u.type === "checkbox-hierarchical" && (c = c.map((l) => l.id === o && l.type === "checkbox-hierarchical" ? I(l, d) : l));
    s = await n.setFacets(c, s);
  }
  if (r.length > 0) {
    const o = s.sort.map((a) => ({
      ...a,
      selected: r.includes(a.id)
    }));
    s = await n.setSortOrder(
      o,
      s
    );
  }
  return s;
}, L = (e) => {
  if (!e)
    return { facets: {}, sort: [] };
  const t = e.facets.reduce(
    (n, s) => {
      const o = T(s);
      return o.length > 0 && (n[s.id] = o), n;
    },
    {}
  ), r = oe(e.sort || []);
  return { facets: t, sort: r };
}, oe = (e) => e.filter((t) => t.selected).map((t) => t.id).sort(), D = (e) => {
  const t = [];
  return Object.keys(e.facets).length > 0 && t.push("facets", e.facets), e.sort.length > 0 && t.push("sort", e.sort), t;
}, T = (e) => {
  var r, n;
  let t = [];
  return e.type === "checkbox-hierarchical" ? t = ae(
    e.values
  ) : e.type === "group" ? t = e.children.flatMap(
    (s) => T(s)
  ) : t = ((n = (r = e.values) == null ? void 0 : r.filter((s) => s.selected)) == null ? void 0 : n.map((s) => s.id)) || [], t.sort();
}, ae = (e) => {
  const t = [];
  for (const r of e)
    r.selected && t.push(r.id), r.children && t.push(...ae(r.children));
  return t;
}, Xe = (e) => {
  const t = {};
  return e.forEach((r, n) => {
    if (n.startsWith("facet_")) {
      const s = n.replace("facet_", "");
      t[s] = r.split(",");
    }
  }), t;
}, Oe = (e) => {
  const t = e.get("sort");
  return t ? t.split(",") : [];
}, K = (e, t, r, n) => {
  const s = new URLSearchParams(r);
  for (const [a] of r.entries())
    a.startsWith("facet_") && s.delete(a);
  s.delete("sort"), e.forEach((a) => {
    let u = [];
    a.type === "checkbox" ? u = a.values.filter((c) => c.selected).map((c) => c.id) : a.type === "checkbox-hierarchical" ? u = Q(a.values).map((d) => d.id) : a.type === "group" && a.children.forEach((c) => {
      let d = [];
      c.type === "checkbox" ? d = c.values.filter((l) => l.selected).map((l) => l.id) : c.type === "checkbox-hierarchical" && (d = Q(c.values).map((i) => i.id)), d.length > 0 && s.set(
        `facet_${c.id}`,
        d.join(",")
      );
    }), a.type !== "group" && u.length > 0 && s.set(`facet_${a.id}`, u.join(","));
  });
  const o = t.filter((a) => a.selected).map((a) => a.id);
  o.length > 0 && s.set("sort", o.join(",")), window.history.replaceState(
    null,
    "",
    `${n}?${s.toString()}`
  );
}, st = (e, t) => {
  const r = new URLSearchParams(e);
  for (const [n] of e.entries())
    n.startsWith("facet_") && r.delete(n);
  r.delete("sort"), window.history.replaceState(
    null,
    "",
    `${t}?${r.toString()}`
  );
}, Te = (e, t, r, n, s) => async (o, a) => {
  var c, d;
  const u = ((c = e.data) == null ? void 0 : c.pages.length) || 0;
  if (o === u + 1) {
    const l = await e.fetchNextPage(), i = (d = l.data) == null ? void 0 : d.pages[l.data.pages.length - 1], S = s();
    if (l.data && S) {
      const h = l.data.pages.flatMap(
        (g) => Array.isArray(g) ? g : g && typeof g == "object" && "items" in g ? g.items : []
      ), m = {
        ...S,
        items: h,
        meta: {
          ...S.meta,
          currentPage: l.data.pages.length
        }
      };
      r.setQueryData(n, m);
    }
    return i && typeof i == "object" && "items" in i ? i.items : [];
  }
  return await t.loadPage(o, a);
}, Ve = (e, t, r, n, s, o, a, u) => ({
  ...e,
  // Apply facet filters while maintaining cache and URL state
  setFacets: async (c, d) => {
    const l = await e.setFacets(
      c,
      d
    ), i = (n == null ? void 0 : n.sort) || [], { urlFacetsData: S, urlSortData: h } = u(
      c,
      i
    ), m = F(
      r,
      S,
      h
    );
    return t.setQueryData(m, l), a(l), K(
      c,
      i,
      s,
      o
    ), l;
  },
  // Apply sort order changes while maintaining cache and URL state
  setSortOrder: async (c, d) => {
    const l = await e.setSortOrder(
      c,
      d
    ), i = (n == null ? void 0 : n.facets) || [], { urlFacetsData: S, urlSortData: h } = u(
      i,
      c
    ), m = F(
      r,
      S,
      h
    );
    return t.setQueryData(m, l), a(l), K(
      i,
      c,
      s,
      o
    ), l;
  },
  reset: async () => {
    const c = F(r, {}, []), d = t.getQueryData(c);
    if (d) {
      await t.cancelQueries({
        queryKey: ["search", r, "infinite"],
        exact: !1
      }), t.removeQueries({
        queryKey: ["search", r, "infinite"],
        exact: !1
      });
      const h = new URLSearchParams(s);
      for (const [f] of s.entries())
        f.startsWith("facet_") && h.delete(f);
      h.delete("sort");
      const m = h.toString(), g = m ? `${o}?${m}` : o;
      return window.history.replaceState(null, "", g), await t.invalidateQueries({
        queryKey: ["search", r],
        exact: !1
      }), a(d), window.scrollTo({ top: 0 }), d;
    }
    const l = new URLSearchParams(s);
    for (const [h] of s.entries())
      h.startsWith("facet_") && l.delete(h);
    l.delete("sort");
    const i = l.toString(), S = i ? `${o}?${i}` : o;
    window.location.href = S;
  }
}), M = async (e, t) => {
  await e.cancelQueries({
    queryKey: ["search", t, "infinite"],
    exact: !1
  }), e.removeQueries({
    queryKey: ["search", t, "infinite"],
    exact: !1
  }), window.scrollTo({ top: 0 });
}, Ae = ({
  queryParams: e,
  searchMethods: t,
  urlFacets: r = {},
  urlSort: n = [],
  mode: s = "CLIENT",
  initialSearchResult: o
}) => {
  var g;
  const a = G(), u = w(
    () => F(e, r, n),
    [e, r, n]
  ), c = ye({
    queryKey: u,
    queryFn: async () => {
      if (s === "SSR" && o)
        return o;
      if (Object.keys(r).length > 0 || n.length > 0) {
        const f = await t.fetchSearchResult();
        return await De(
          f,
          r,
          n,
          t
        );
      }
      return t.fetchSearchResult();
    },
    initialData: s === "SSR" && o ? o : void 0,
    staleTime: s === "SSR" ? 1 / 0 : void 0,
    refetchOnWindowFocus: !1
  }), d = w(
    () => L(c.data),
    [c.data]
  ), l = w(
    () => [
      "search",
      e,
      "infinite",
      ...D(d)
    ],
    [e, d]
  ), i = we({
    queryKey: l,
    queryFn: async ({ pageParam: f = 1 }) => {
      var y, R;
      if (f === 1) {
        if (!c.data)
          throw new Error("Cannot start infinite query without search data");
        return c.data;
      }
      const p = await t.loadPage(f, c.data);
      return {
        items: p,
        meta: {
          currentPage: f,
          totalPages: ((y = c.data) == null ? void 0 : y.meta.totalPages) || 0,
          totalItems: ((R = c.data) == null ? void 0 : R.meta.totalItems) || 0,
          itemsPerPage: p.length
        }
      };
    },
    getNextPageParam: (f, p) => {
      var R;
      const y = p.length;
      return y < (((R = f.meta) == null ? void 0 : R.totalPages) || 0) ? y + 1 : void 0;
    },
    initialPageParam: 1,
    enabled: !!c.data,
    refetchOnWindowFocus: !1
  }), S = {
    // Load additional pages using infinite query pattern
    loadPage: C(
      Te(
        i,
        t,
        a,
        u,
        () => c.data
      ),
      [
        i,
        t,
        a,
        u,
        c.data
      ]
    ),
    // Apply facet filters and update base cache
    setFacets: C(
      async (f, p) => {
        const y = await t.setFacets(
          f,
          p
        );
        return await M(a, e), a.setQueryData(u, y), y;
      },
      [t, a, u, e, l]
    ),
    // Apply sort order changes
    setSortOrder: C(
      async (f, p) => {
        const y = await t.setSortOrder(
          f,
          p
        );
        return await M(a, e), a.setQueryData(u, y), y;
      },
      [t, a, e, l]
    ),
    // Reset search to initial state
    reset: C(async () => c.data || await c.refetch().then((f) => f.data), [c])
  }, h = w(
    () => {
      var f;
      return ((f = i.data) == null ? void 0 : f.pages.flatMap((p) => Array.isArray(p) ? p : p && typeof p == "object" && "items" in p ? p.items : [])) || [];
    },
    [i.data]
  );
  return {
    results: w(
      () => {
        var f;
        return c.data ? {
          ...c.data,
          items: h.length > 0 ? h : c.data.items,
          meta: {
            ...c.data.meta,
            currentPage: ((f = i.data) == null ? void 0 : f.pages.length) || 1
          }
        } : void 0;
      },
      [c.data, h, (g = i.data) == null ? void 0 : g.pages.length]
    ),
    queryMethods: S
  };
}, Ue = (e, t, r, n) => {
  const s = L(r), o = [
    "search",
    t,
    "infinite",
    ...D(s)
  ], a = L(n), u = [
    "search",
    t,
    "infinite",
    ...D(a)
  ], c = e.getQueryData(o);
  if (c != null && c.pages && c.pages.length > 1) {
    const d = {
      ...c,
      pages: [n, ...c.pages.slice(1)],
      pageParams: c.pageParams
    };
    e.setQueryData(u, d);
  }
}, _e = ({
  queryParams: e,
  searchMethods: t,
  mode: r = "CLIENT",
  initialSearchResult: n,
  children: s
}) => {
  const o = x(b), a = G();
  if (!o)
    throw new Error(
      "CachedSearchResultsProvider must be used within a SearchProvider"
    );
  const { searchData: u } = o, c = u.urlSearchParams, d = w(
    () => Xe(c),
    [c.toString()]
  ), l = w(
    () => Oe(c),
    [c.toString()]
  ), { results: i, queryMethods: S } = Ae({
    queryParams: e,
    searchMethods: t,
    urlFacets: d,
    urlSort: l,
    mode: r,
    initialSearchResult: n
  }), h = (f, p) => {
    const y = f.reduce(
      (U, _) => {
        const N = T(_);
        return N.length > 0 && (U[_.id] = N), U;
      },
      {}
    ), R = oe(p);
    return { urlFacetsData: y, urlSortData: R };
  }, m = C(
    (f) => {
      Ue(a, e, i, f);
    },
    [a, e, i]
  ), g = Ve(
    S,
    a,
    e,
    i,
    c,
    u.pathname,
    m,
    h
  );
  return /* @__PURE__ */ v(re.Provider, { value: g, children: /* @__PURE__ */ v(ne, { result: i, children: s }) });
};
_e.displayName = "CachedSearchResultsProvider";
function V() {
  const e = x(ee);
  if (e === void 0)
    throw new Error(
      "useSearchResultDispatch must be used within a SearchResultProvider"
    );
  return e;
}
const A = () => {
  const e = x(re);
  if (e === void 0)
    throw new Error(
      "useSearchResultQueryMethods must be used within a SearchResultProvider"
    );
  return e;
}, ct = () => {
  const e = x(b);
  if (!e)
    throw new Error(
      "useGlobalSearchSettings must be used within a SearchProvider"
    );
  return e.globalSearchSettings;
}, ie = () => {
  const e = x(b);
  if (!e)
    throw new Error("useSearchData must be used within a SearchProvider");
  return e.searchData;
}, Ne = () => {
  const { loadPage: e } = A(), { result: t } = E(), r = V();
  return async (n) => {
    const s = await e(n, t);
    r({ type: "LOAD_PAGE", payload: { items: s, page: n } });
  };
}, ue = () => {
  const { result: e } = E();
  return e == null ? void 0 : e.meta;
}, Ke = () => {
  const { urlSearchParams: e, pathname: t } = ie(), r = ue(), n = r ? r.currentPage + 1 : 0, s = new URLSearchParams(e);
  return s.set("page", n.toString()), `${t}?${s.toString()}`;
}, ot = () => {
  const e = H(!1), t = ue(), r = Ke(), n = Ne(), [s, o] = pe(!1);
  if (!t)
    return {
      loadMore: () => {
      },
      canLoadMore: !1,
      paginationStats: { totalItems: 0, seen: 0 },
      isLoading: !1,
      pageIncrementHref: r
    };
  const { currentPage: a, totalPages: u, itemsPerPage: c, totalItems: d } = t;
  a === 0 && !e.current && (e.current = !0);
  const l = a + (e.current ? 1 : 0) < u, i = () => {
    if (l)
      return o(!0), n(a + 1).finally(() => o(!1));
    console.warn(
      `Tried to load more products than available, currentPage: ${a}, totalPages: ${u}`
    );
  }, S = (a + (e.current ? 1 : 0)) * c > d ? d : (a + (e.current ? 1 : 0)) * c;
  return {
    loadMore: i,
    canLoadMore: l,
    paginationStats: { totalItems: d, seen: S },
    isLoading: s,
    pageIncrementHref: r
  };
}, at = () => {
  const e = E(), t = V(), { setSortOrder: r } = A(), n = w(() => {
    var o;
    return ((o = e.result) == null ? void 0 : o.sort) || [];
  }, [e.result]), s = C(
    async (o) => {
      const a = n.map((c) => c.id === o ? {
        ...c,
        selected: !c.selected
      } : {
        ...c,
        selected: !1
        // Only one sort can be selected at a time
      });
      if (!a)
        return;
      const u = await r(a, e.result);
      t({ type: "SET_RESULT", payload: u });
    },
    [n, r, t]
  );
  return { sortAlternatives: n, toggleSort: s };
}, Me = (e, t) => {
  const r = [], n = /* @__PURE__ */ new Set();
  for (const o of t) {
    const a = e.filter(
      (u) => o.facetIds.includes(u.id) && (u.type === "checkbox" || u.type === "checkbox-hierarchical")
    );
    if (a.length > 0) {
      const u = a.reduce(
        (d, l) => d + l.selectedCount,
        0
      ), c = {
        id: o.id,
        name: o.name,
        type: "group",
        children: a,
        selectedCount: u,
        relationship: o.relationship || "or",
        compositeField: o.compositeField
      };
      r.push(c), a.forEach((d) => n.add(d.id));
    }
  }
  const s = e.filter(
    (o) => !n.has(o.id)
  );
  return r.push(...s), r;
}, le = (e) => {
  if (e.type === "group")
    return {
      ...e,
      children: e.children.map(le)
    };
  if (e.type === "checkbox")
    return {
      ...e,
      values: e.values.filter((t) => t.name !== "undefined")
    };
  if (e.type === "checkbox-hierarchical") {
    const t = (r) => r.filter((n) => n.name !== "undefined").map((n) => ({
      ...n,
      children: n.children ? t(n.children) : void 0
    }));
    return {
      ...e,
      values: t(e.values)
    };
  }
  return e;
}, de = (e) => e.type === "group" ? e.children.some(de) : e.type === "checkbox" || e.type === "checkbox-hierarchical" ? e.values.length > 0 : !0, $e = /* @__PURE__ */ new Set(["ONE SIZE", "ONESIZE", "ONE-SIZE", "OS"]), je = [
  "XXXS",
  "XXS",
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
  "XXXL",
  "XXXXL",
  "XXXXXL"
], He = -1;
function Ge(e) {
  const t = e.trim().toUpperCase(), r = t.match(/^(\d+)\s*(XL|XS)$/);
  if (r) {
    const n = r[1], s = r[2];
    if (n && s) {
      const o = s === "XL" ? "L" : "S";
      return "X".repeat(Number(n)) + o;
    }
  }
  return t;
}
function $(e) {
  const t = Ge(e);
  if ($e.has(t))
    return He;
  const r = je.indexOf(t);
  return r === -1 ? null : r;
}
function j(e) {
  const t = e.trim().match(/^(\d+(?:[.,]\d+)?)/), r = t == null ? void 0 : t[1];
  return r ? Number(r.replace(",", ".")) : null;
}
function We(e, t) {
  const r = $(e), n = $(t);
  if (r !== null && n !== null)
    return r - n;
  if (r !== null)
    return -1;
  if (n !== null)
    return 1;
  const s = j(e), o = j(t);
  return s !== null && o !== null && s !== o ? s - o : e.localeCompare(t, void 0, { numeric: !0 });
}
function X(e, t) {
  return t === "auto" ? e : [...e].sort((r, n) => t === "name" ? We(r.name, n.name) : t === "count" ? n.count - r.count : 0);
}
function O(e, t) {
  return X(e, t).map(
    (r) => r.children ? { ...r, children: O(r.children, t) } : r
  );
}
function Ze(e, t) {
  return t === "auto" ? e : e.type === "group" ? {
    ...e,
    children: e.children.map((r) => r.type === "checkbox-hierarchical" ? {
      ...r,
      values: O(r.values, t)
    } : { ...r, values: X(r.values, t) })
  } : e.type === "checkbox-hierarchical" ? {
    ...e,
    values: O(e.values, t)
  } : { ...e, values: X(e.values, t) };
}
const it = () => {
  const e = Pe(), t = Re(), r = Ce(), n = E(), s = V(), { setFacets: o, reset: a } = A(), u = w(() => {
    var S;
    if (!((S = n.result) != null && S.facets))
      return [];
    let i = n.result.facets.sort((h, m) => e.facets === "count" ? 0 : e.facets === "name" ? h.name.localeCompare(m.name) : 0).filter((h) => h.id && !t.includes(h.id));
    if (r) {
      const h = r();
      i = Me(i, h);
    }
    return i = i.map(le), i = i.filter(de), i = i.map(
      (h) => Ze(h, e.values ?? "auto")
    ), i;
  }, [
    n.result,
    e.facets,
    e.values,
    t,
    r
  ]), c = w(() => {
    const i = [], S = (h) => {
      h.type === "checkbox-hierarchical" ? Le(
        h.values
      ).forEach((g) => {
        i.push({
          name: g.name,
          id: g.id,
          facetId: h.id
        });
      }) : h.type === "checkbox" ? h.values.forEach((m) => {
        m.selected && i.push({
          name: m.name,
          id: m.id,
          facetId: h.id
        });
      }) : h.type === "group" && h.children.forEach(S);
    };
    return u.forEach(S), i;
  }, [u]), d = C(
    async (i, S) => {
      const h = u.map((g) => {
        if (g.type === "group") {
          const f = g.children.map((p) => {
            if (p.id === i) {
              if (p.type === "checkbox-hierarchical")
                return I(p, S);
              if (p.type === "checkbox")
                return k(p, S);
            }
            return p;
          });
          return {
            ...g,
            children: f,
            selectedCount: f.reduce(
              (p, y) => p + y.selectedCount,
              0
            )
          };
        } else if (g.id === i) {
          if (g.type === "checkbox-hierarchical")
            return I(g, S);
          if (g.type === "checkbox")
            return k(g, S);
        }
        return g;
      }), m = await o(
        h,
        n.result
      );
      s({ type: "SET_RESULT", payload: m });
    },
    [u, o, s, n.result]
  );
  return { facets: u, toggleFacet: d, resetFacets: async () => {
    const i = await a();
    s({ type: "SET_RESULT", payload: i });
  }, activeFacetValues: c };
}, ut = ({
  zeroIndexed: e = !1
} = {}) => {
  const { urlSearchParams: t } = ie(), r = t.get("page"), n = r ? parseInt(r) : 1;
  return (isNaN(n) || n < 1 ? 1 : n) - (e ? 1 : 0);
}, lt = {
  items: [],
  meta: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    itemsPerPage: 0
  },
  facets: [],
  sort: []
}, dt = (e) => e.relationship !== "and" ? [] : e.children.map((t) => ({
  facetId: t.id,
  valueIds: t.values.filter((r) => r.selected).map((r) => r.id)
})).filter((t) => t.valueIds.length > 0);
export {
  rt as AutoCompleteProvider,
  _e as CachedSearchResultsProvider,
  be as SearchProvider,
  ne as SearchResultProvider,
  B as SearchResultReactQueryProvider,
  Ie as StructuredDataSearchProducts,
  tt as autoCompleteClientMethods,
  et as clearSearchResultCache,
  st as clearSearchUrlParameters,
  Q as collectSelectedCheckboxHierarchicalValues,
  ae as collectSelectedHierarchicalIds,
  Le as collectTopMostSelectedCheckboxHierarchicalValues,
  We as compareSizeFacetValues,
  Ve as createEnhancedQueryMethods,
  D as createFilterKeyFragment,
  Te as createLoadPageMethod,
  lt as emptySearchResult,
  Z as excludedFacetsContext,
  L as extractFilterState,
  T as extractSelectedFacetIds,
  oe as extractSelectedSortIds,
  J as facetGroupingContext,
  W as facetSortingContext,
  le as filterUndefinedValues,
  F as generateSearchQueryKey,
  dt as getAndGroupActiveSelections,
  Me as groupFacets,
  de as hasValues,
  Ue as migrateInfiniteQueryData,
  Xe as parseUrlFacets,
  Oe as parseUrlSort,
  De as restoreSelectionsFromUrl,
  b as searchContext,
  re as searchResultQueryMethodsContext,
  Fe as searchResultReducer,
  ee as searchResultReducerDispatch,
  q as searchResultReducerState,
  k as toggleCheckboxFacet,
  I as toggleHierarchicalFacet,
  K as updateUrlWithSearchState,
  Ee as useAutoCompleteClient,
  nt as useAutoCompleteSearch,
  Ae as useCachedSearchResults,
  ut as useCurrentPaginationPage,
  Re as useExcludedFacets,
  Ce as useFacetGrouping,
  Pe as useFacetSorting,
  it as useFacets,
  ct as useGlobalSearchSettings,
  Ke as usePageIncrementedHref,
  ie as useSearchData,
  V as useSearchResultDispatch,
  ke as useSearchResultItems,
  ot as useSearchResultLoadMore,
  Ne as useSearchResultLoadPage,
  ue as useSearchResultMeta,
  A as useSearchResultQueryMethods,
  E as useSearchResultState,
  at as useSort,
  te as useStructuredDataProductsMapper
};
